import { SVGProps, Ref, forwardRef, memo } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={11} height={8} fill="none" ref={ref} {...props}>
    <path
      fill={props?.fill || '#383838'}
      d="M10.354 4.354a.5.5 0 0 0 0-.708L7.172.464a.5.5 0 1 0-.708.708L9.293 4 6.464 6.828a.5.5 0 1 0 .708.708l3.182-3.182ZM0 4.5h10v-1H0v1Z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgComponent);
const GoToDetailsArrow = memo(ForwardRef);
export default GoToDetailsArrow;
